package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.animation.Keyframes
import com.varabyte.kobweb.silk.components.animation.toAnimation
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

val SpinLoader by Keyframes {
    from {
        Modifier.rotate(0.deg)
    }
    to { Modifier.rotate(360.deg) }
}

@Composable
fun LoadingView(modifier: Modifier = Modifier, size: CSSSizeValue<CSSUnit.px> = 28.px) {
    Box(
        modifier = modifier.fillMaxSize()
            .alignSelf(AlignSelf.Center),
        contentAlignment = Alignment.Center
    ) {
        Div(
            attrs = Modifier
                .size(size)
                .alignSelf(AlignSelf.Center)
                .borderTop(2.px, style = LineStyle.Solid)
                .borderRadius(50.percent)
                .animation(
                    SpinLoader.toAnimation(
                        duration = 800.ms,
                        timingFunction = AnimationTimingFunction.Linear,
                        iterationCount = AnimationIterationCount.Infinite
                    )
                )
                .toAttrs()
        )
    }
}

@Composable
fun LoadingFrame() {
    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {

    }
}